import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CartComponent implements OnInit {
  user : firebase.User;

  constructor(private afAuth:AngularFireAuth) {
    afAuth.authState.subscribe( user => this.user = user);
  }

  ngOnInit() {
  }

}
